<template>
<div>
    <nav class="myHeader">

        <a>접속자: {{ userName }} 님</a>

        <a> | </a>

        <div class="adminBtn" v-if="this.$store.state.isAdmin">
            <a class="admin" :href="adminPageUrl">관리자페이지</a>

            <a> | </a>
        </div>
        
        <el-button type="text" @click="doLogout">
            로그아웃
        </el-button>

        <a style="margin-left: 10px"> | </a>

        <router-link :to="{ name: '차량 등록 관리' }">
            <el-button type="text" @click="resetActive" @mouseout="resetActive">
            마이페이지
            </el-button>
        </router-link>

        <a> | </a>

        <router-link :to="{name: '사이트맵정보'}">
            <el-button type="text" @click="resetActive" @mouseout="resetActive">
                사이트맵
            </el-button>
        </router-link>
        
    </nav>
</div>
</template>

<script>
import build from '@/api/example'

export default {
    methods: {
        doLogout() {
            console.log('do logout');
            build.get('/mer/api/member/logout')
            .then(res => {
                console.log(res);
                this.$store.state.isLogin = false;
                this.$store.state.isAdmin = false;
                this.$store.state.isBusiness = false;

                this.$store.firstMenu = false
                this.$store.secondMenu = false
                this.$store.thirdMenu = false
                this.$store.fourthMenu = false

                this.$cookies.remove("JSESSIONID");

                this.$router.push({name: '홈'});
                this.$router.go(0);
                this.$store.state.popupCheck = true;
            })
            .catch(err => {
                console.log(err);
            })
        },
        resetActive() {
            this.$store.isActive = false;
            this.$store.isSubmit = false;

            this.$store.firstMenu = false;
            this.$store.secondMenu = false;
            this.$store.thirdMenu = false;
            this.$store.fourthMenu = false;
        },
        setUserName() {

            build.get('/api/member/userName')
            .then(res => {
                this.userName = res.data;

                // console.log(this.userName);
            }).catch(err => {
                console.log(err);
            })

        }
    },
    data() {
        return {
            adminPageUrl: process.env.VUE_APP_ADMINPAGE_URL,
            userName: ''
        }
    },
    mounted() {
        this.setUserName();
    }
}

</script>

<style scoped>
@import '@/assets/css/reset.css';

    div {
        width: 100vh;
    }

    .myHeader {
        max-width: 1200px;
        width: 90%;
        margin: auto;
        font-size: 25px;
        text-align: right;
    }

    a {
        margin-right: 9px;
        font: normal normal 14px/20px Noto Sans KR-BOLD;
        letter-spacing: -0.35px;
        color: #4C4C4C;
    }

    .el-button {
        font: normal normal 14px/20px Noto Sans KR-BOLD;
        letter-spacing: -0.35px;
        color: #4C4C4C;
        margin-top: 2.6%;
    }

    /* hover event시 text색 바뀜 */
    .el-button:hover {
        color: #008FD2;

    }

    .adminBtn {
        width: 102px;
        display: inline-block;
    }

    .admin {
        margin: 0;
        display: inline-block;
        text-decoration: none;
        padding: 12px 10px 0 0;
    }

    /* 반응형 웹 CSS */
    @media all and (max-width: 1200px) {

        .myHeader {
            width: 98vw;
        }

        nav {
            float: left;
            margin-right: -2% !important;
        }
    }

    @media all and (max-width: 1024px) {

        .myHeader {
            width: 98vw;
        }
    }
</style>